import * as CryptoJS from 'crypto-js';
export class encryptdecrypt{
    encryptKey="b14ca5898a4e4133";
    constructor() { }

    encryptUsingAES256(plaintext) {
        let key = CryptoJS.enc.Utf8.parse(this.encryptKey);
        let iv = CryptoJS.enc.Utf8.parse(this.encryptKey);
        var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(plaintext), key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });     
       
        return encrypted.toString();
    }


 decryptUsingAES256(decString) {
    
    let key = CryptoJS.enc.Utf8.parse(this.encryptKey);
    let iv = CryptoJS.enc.Utf8.parse(this.encryptKey);
  var decrypted = CryptoJS.AES.decrypt(decString, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
  });
 // console.log('Decrypted : ' + decrypted);
 // console.log('utf8 = ' + decrypted.toString(CryptoJS.enc.Utf8));
 return decrypted.toString(CryptoJS.enc.Utf8);

}
}